'use client';

import React, { useEffect, useState } from 'react';
import { Button } from '@/components/ui/Button';
import Image from 'next/image';
import Link from 'next/link';
import { Rocket } from 'lucide-react';

interface NavItem {
  label: string;
  url: string;
}

interface CampaignNavigationBarProps {
  items?: NavItem[];
}

const CampaignNavigationBar = ({ items = [] }: CampaignNavigationBarProps) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const navClasses = [
    'transition-colors',
    'duration-300',
    'ease-in-out',
    ...(isScrolled ? ['bg-white/85', 'backdrop-blur-xs', 'shadow-md'] : []),
    'fixed',
    'w-full',
    'top-0',
    'z-50',
  ].join(' ');

  return (
    <nav className={navClasses}>
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          {/* Logo — not clickable */}
          <div className="flex-shrink-0">
            <Image
              src="/images/logo-horizontal-orange-blue.svg"
              width={192}
              height={24}
              alt="Trovanorma"
              className="inline-block mx-2"
            />
          </div>

          {/* Nav items + CTA */}
          <div className="flex items-center space-x-1 lg:space-x-3">
            {items.map(item => (
              <Link
                key={item.url}
                href={item.url}
                className="hidden md:inline-block text-gray-600 hover:text-primary-600 px-2 lg:px-3 py-2 rounded-md text-sm font-medium transition duration-150 ease-in-out"
              >
                {item.label}
              </Link>
            ))}
            <Button asChild variant="accent-default" size="sm" className="ml-3">
              <Link href={process.env.NEXT_PUBLIC_APP_URL + '/signup'}>
                <Rocket className="w-5 h-5 mr-2" />
                Provalo ora
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default CampaignNavigationBar;
